var Config = require(`./vars/${process.env.REACT_APP_SITE}.js`).default;
require(`./css/${process.env.REACT_APP_SITE}.css`);

if (typeof process.env.REACT_APP_SEARCH_HOST  !== 'undefined')
    Config.backend.host = process.env.REACT_APP_SEARCH_HOST;

export default Config;